import { render, staticRenderFns } from "./WhatsNewButton.vue?vue&type=template&id=7d6043f9"
import script from "./WhatsNewButton.vue?vue&type=script&lang=js"
export * from "./WhatsNewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports